import React from "react";
import IconTg from "../../../mui/JSXIcons/IconTg.jsx";
import IconReload from "../../../mui/JSXIcons/IconReload.jsx";
import IconFavorite from "../../../mui/JSXIcons/IconFavorite.jsx";
import { useTranslation } from "react-i18next";
import { ENUM_GAME_TYPE, ENUM_LCS_NAME, TEST_MODE } from "../../../../store/enums.js";
import { useAppSelector } from "../../../../store/index.ts";
import "./aside-buttons-find.scss";
import { useReadLocalStorage } from "usehooks-ts";
import { Link, useLocation } from "react-router-dom";
import useGetLinkCallback from "../../../../hooks/other/useGetLinkCallback.js";
import CusButton from "../../../mui/custom_button/CusButton.jsx";
import CustomCarousel from "../../../mui/custom-carousel/CustomCarousel.jsx";

export default function AsideButtonFind() {
  const { t } = useTranslation();
  const useGetLink = useGetLinkCallback();

  const start_r = useReadLocalStorage(ENUM_LCS_NAME.startR) || "";

  const botName = useAppSelector((state) => state.common.botName);
  const historyIdList = useAppSelector((state) => state.games.histories.ids);
  const currency = useAppSelector((state) => state.user.currency);
  const favoritesGames = useAppSelector((state) => state.games.favorites.list);
  const isTgBot = useAppSelector((state) => state.common.isTgBot);
  const isMobileSize = useAppSelector((state) => state.deviceSize.isMobileSize);

  const location = useLocation();
  const pathname = location.pathname;

  const historyGamesId = historyIdList[currency] || [];
  const isFavorites = !!favoritesGames.length;
  const isHistory = !!historyGamesId.length;

  const casinoLink = start_r
    ? `https://t.me/${botName}?start_r=${start_r}`
    : `https://t.me/${botName}`;

  const favorites = {
    id: ENUM_GAME_TYPE.favorites,
    title: t("Favorites Games"),
    icon: <IconFavorite />,
    navigate: "/games/favorites"
  };

  const history = {
    id: ENUM_GAME_TYPE.history,
    title: t("My game`s history"),
    icon: <IconReload />,
    navigate: "/games/history"
  };

  const casino = {
    id: "casino",
    title: t("Telegram casino"),
    icon: <IconTg />,
    link: casinoLink
  };

  const items = [];
  if (isFavorites || TEST_MODE) items.push(favorites);
  if (isHistory || TEST_MODE) items.push(history);
  if (casinoLink && !isTgBot) items.push(casino);

  const ButtonLink = ({ item }) => {
    const isActive = item.navigate && item.navigate == pathname;
    const activeClass = isActive ? "active" : "";

    return item.navigate ? (
      <Link
        className={`aside-button__item ${activeClass}`}
        draggable="false"
        to={useGetLink(item.navigate)}>
        {item.icon}
        <span>{t(item.title)}</span>
      </Link>
    ) : (
      <CusButton
        className={`aside-button__item ${activeClass}`}
        href={item.link}
        target="_blank"
        rel="noreferrer"
        color="custom"
        defCusColor="gradient-blue"
        draggable="false"
        text={item.title}
      />
    );
  };

  return (
    <div className="aside-button-find">
      {items.length > 2 && isMobileSize ? (
        <CustomCarousel
          className="aside-button-find__nav"
          loop={false}
          autoplay={{ delay: 10_000 }}
          slidesPerView={"auto"}
          spaceBetween={12}
          freeMode={true}>
          {items.map((item, indx) => (
            <ButtonLink item={item} key={indx} />
          ))}
        </CustomCarousel>
      ) : (
        <nav className="aside-button-find__nav">
          {items.map((item, indx) => (
            <ButtonLink item={item} key={indx} />
          ))}
        </nav>
      )}
    </div>
  );
}
